
const enum LiveLabStatusCodesEnum {
  UNAUTHORIZED = 1,
  BUSY = 2,
  AVAILABLE = 3
};

export default LiveLabStatusCodesEnum;
